module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content-nav__wrapper"
  }, [_c('div', {
    staticClass: "title-wrapper"
  }, [_c('span', {
    staticStyle: {
      "color": "#999999"
    }
  }, [_vm._v("配音类型")]), _vm._v(" "), _c('button', {
    class: {
      'active': _vm.typeCode === 0
    },
    on: {
      "click": function($event) {
        _vm.getTaskList(0, _vm.statusCode, 1)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('word.all')))])]), _vm._v(" "), _c('button', {
    class: {
      'active': _vm.typeCode === 1
    },
    on: {
      "click": function($event) {
        _vm.getTaskList(1, _vm.statusCode, 1)
      }
    }
  }, [_c('span', [_vm._v("小说书籍")])]), _vm._v(" "), _c('button', {
    class: {
      'active': _vm.typeCode === 2
    },
    on: {
      "click": function($event) {
        _vm.getTaskList(2, _vm.statusCode, 1)
      }
    }
  }, [_c('span', [_vm._v("专栏文章")])]), _vm._v(" "), _c('button', {
    class: {
      'active': _vm.typeCode === 3
    },
    on: {
      "click": function($event) {
        _vm.getTaskList(3, _vm.statusCode, 1)
      }
    }
  }, [_c('span', [_vm._v("亲子儿童")])])]), _vm._v(" "), _c('div', {
    staticClass: "title-wrapper"
  }, [_c('span', {
    staticStyle: {
      "color": "#999999"
    }
  }, [_vm._v("任务状态")]), _vm._v(" "), _c('button', {
    class: {
      'active': _vm.statusCode === 0
    },
    on: {
      "click": function($event) {
        _vm.getTaskList(_vm.typeCode, 0, 1)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('word.all')))])]), _vm._v(" "), _c('button', {
    class: {
      'active': _vm.statusCode === 1
    },
    on: {
      "click": function($event) {
        _vm.getTaskList(_vm.typeCode, 1, 1)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('word.inProduction')))])]), _vm._v(" "), _c('button', {
    class: {
      'active': _vm.statusCode === 2
    },
    on: {
      "click": function($event) {
        _vm.getTaskList(_vm.typeCode, 2, 1)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('word.acceptance')))])]), _vm._v(" "), _c('button', {
    class: {
      'active': _vm.statusCode === 4
    },
    on: {
      "click": function($event) {
        _vm.getTaskList(_vm.typeCode, 4, 1)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('comb.acceptanceRejection')))])]), _vm._v(" "), _c('button', {
    class: {
      'active': _vm.statusCode === 3
    },
    on: {
      "click": function($event) {
        _vm.getTaskList(_vm.typeCode, 3, 1)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('word.finished')))])])])]), _vm._v(" "), (_vm.totalCount === 0 && _vm.statusCode === 0) ? _c('div', {
    staticClass: "copyright-empty-task-list"
  }, [_c('p', {
    staticClass: "no-task"
  }, [_vm._v("您可以通过"), _c('a', {
    attrs: {
      "href": ((_vm.$store.state.A_PC_HOST) + "/requirementview")
    }
  }, [_vm._v("参加海选")]), _vm._v("获得更多播讲机会")])]) : _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.pageLoading),
      expression: "pageLoading",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "copyright-tasks-list__wrapper"
  }, [_c('div', {
    staticClass: "copyright-tasks-list__title-wrapper"
  }, [_c('span', {
    staticClass: "copyright-tasks-list__work-info"
  }, [_vm._v("作品信息")]), _vm._v(" "), _c('span', {
    staticClass: "copyright-task-list__type"
  }, [_vm._v("类型")]), _vm._v(" "), _c('span', {
    staticClass: "copyright-task-list__deliver-date"
  }, [_vm._v("更新/交付")]), _vm._v(" "), _c('span', {
    staticClass: "copyright-task-list__status-code"
  }, [_vm._v("状态")]), _vm._v(" "), _c('span', {
    staticClass: "copyright-task-list__operation"
  }, [_vm._v("操作")])]), _vm._v(" "), _vm._l((_vm.taskList), function(item, index) {
    return _c('div', {
      staticClass: "copyright-tasks-list-item-wrapper"
    }, [_c('div', {
      staticClass: "copyright-tasks-list__work-info"
    }, [(item.coverPath) ? _c('img', {
      ref: "img",
      refInFor: true,
      staticClass: "copyright-tasks-list__book-cover",
      attrs: {
        "src": _vm.$store.state.UPLOAD_IMG_HOST + item.coverPath
      },
      on: {
        "error": function($event) {
          _vm.setDefaultBookCoverImg(index)
        }
      }
    }) : _c('img', {
      staticClass: "copyright-tasks-list__book-cover",
      attrs: {
        "src": _vm.$store.state.IMG_HOST + 'bookCoverDefault.png'
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "padding": "15px",
        "word-break": "break-all"
      }
    }, [_vm._v(_vm._s(item.requirementName))])]), _vm._v(" "), _c('span', {
      staticClass: "copyright-task-list__type"
    }, [_vm._v("\n            " + _vm._s(item.dubbingTypeStr) + "\n          ")]), _vm._v(" "), _c('span', {
      staticClass: "copyright-task-list__deliver-date"
    }, [_vm._v("\n            " + _vm._s(item.deliveryTimeStr || item.deliveryFrequencyStr) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "copyright-task-list__status-code"
    }, [_c('span', [_vm._v(_vm._s(_vm.getStatusLabel(item.taskStatusId)))]), _vm._v(" "), (item.exchangeEvent && item.exchangeEvent.status === 1) ? _c('span', {
      staticClass: "vacation-label"
    }, [_vm._v("请假审核中")]) : _vm._e(), _vm._v(" "), (item.exchangeEvent && item.exchangeEvent.status === 2 && _vm.isEarlierThanNow(item.exchangeEvent.startTime)) ? _c('span', {
      staticClass: "vacation-label"
    }, [_vm._v("请假中")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "copyright-task-list__operation copyright-task-list-item-buttons"
    }, [(item.dubbingType === 'book') ? _c('a', {
      staticClass: "check-task",
      attrs: {
        "href": ((_vm.$store.state.A_PC_HOST) + "/requirement/" + (item.requirementId) + "/candidate"),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(_vm.$t('word.check')))]) : _c('a', {
      staticClass: "check-task",
      attrs: {
        "href": ((_vm.$store.state.A_PC_HOST) + "/dub/anchors/requirements/" + (item.requirementId)),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(_vm.$t('word.check')))]), _vm._v(" "), (item.exchangeEvent && (item.exchangeEvent.status === 1 || (item.exchangeEvent.status === 2 && !_vm.isEarlierThanNow(item.exchangeEvent.endTime)))) ? _c('a', {
      staticClass: "check-task-vacation-btn",
      on: {
        "click": function($event) {
          _vm.showVacationInfo(item.exchangeEvent)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.$t('word.check')) + _vm._s(_vm.$t('word.vacate')) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
      attrs: {
        "close-on-click-modal": false,
        "title": ("" + (_vm.$t('word.check')) + (_vm.$t('word.vacate'))),
        "size": "tiny"
      },
      model: {
        value: (_vm.isShowVacationInfo),
        callback: function($$v) {
          _vm.isShowVacationInfo = $$v
        },
        expression: "isShowVacationInfo"
      }
    }, [_c('div', {
      staticClass: "pop-vacation-info",
      slot: "default"
    }, [_c('p', [_c('span', [_vm._v(_vm._s(_vm.$t('word.suspendTime')) + "：")]), _c('span', [_vm._v(_vm._s(_vm.$t('word.from')) + "\n                          " + _vm._s(_vm.formatDate(_vm.vacationInfo.startTime)) + " " + _vm._s(_vm.$t('word.to')) + " " + _vm._s(_vm.formatDate(_vm.vacationInfo.endTime)) + "\n                          " + _vm._s(_vm.$t('word.total')) + _vm._s(_vm.getDuration(_vm.vacationInfo.startTime, _vm.vacationInfo.endTime)) + "\n                          " + _vm._s(_vm.$t('word.day')))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v(_vm._s(_vm.$t('comb.additionalRemarks')) + "：")]), _c('span', [_vm._v(_vm._s(_vm.vacationInfo.description))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v(_vm._s(_vm.$t('comb.commitTime')) + "：")]), _c('span', [_vm._v(_vm._s(_vm.formatDate(_vm.vacationInfo.createTime)))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v(_vm._s(_vm.$t('word.status')) + "：")]), (_vm.vacationInfo.status === 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('word.toBeAudit')))]) : _vm._e(), (_vm.vacationInfo.status === 2) ? _c('span', [_vm._v(_vm._s(_vm.$t('word.passAudit')))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "buttons"
    }, [_c('el-button', {
      attrs: {
        "type": "primary",
        "size": "small"
      },
      on: {
        "click": function($event) {
          _vm.isShowVacationInfo = false;
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('word.close')))]), _vm._v(" "), _c('el-button', {
      attrs: {
        "size": "small"
      },
      on: {
        "click": _vm.cancelVacation
      }
    }, [_vm._v(_vm._s(_vm.$t('word.cancel')) + _vm._s(_vm.$t('word.vacate')))])], 1)]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "none"
      },
      slot: "footer"
    })])], 1)])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "center-tasks-pagination"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('word.total')) + " " + _vm._s(_vm.totalCount) + " " + _vm._s(_vm.$t('word.item')))]), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.pageIndex,
      "page-count": _vm.totalPage,
      "layout": "prev, pager, next"
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-28ab4c7e!./~/vue-loader/lib/selector.js?type=template&index=0!./views/anchor/center/MyAudioBook.vue
// module id = 406
// module chunks = 0